<template>
  <ModalComponent
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="46"
    :style-class="styleClass"
    :style-class-contain="styleClassContain"
    :class-name="`tw-z-[1072] modal-evidence tw-top-0`"
  >
    <ModalHeader
      :title="
        isVendorRequest
          ? getComponentUiText(
              'app-component-assessments-securing-evidence-vendor-modal-title-1',
            )
          : getComponentUiText(
              'app-component-assessments-securing-evidence-modal-title-1',
            )
      "
      :class="'tw-px-[20px] sm:tw-px-[40px]'"
      @close="handleCloseModal"
    />
    <div
      :class="`tw-px-[20px] tw-pb-[40px] sm:tw-px-[40px] tw-pt-[20px] sm:tw-pt-[40px]`"
    >
      <div
        :class="`tw-text-[25px] tw-text-[#211F58] tw-font-[Poppins] tw-font-[600] tw-mb-[15px] tw-leading-[145%]`"
      >
        {{
          type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT
            ? getComponentUiText(
                "app-component-assessments-securing-evidence-modal-title-encrypt-1",
              )
            : getComponentUiText(
                "app-component-assessments-securing-evidence-modal-title-decrypt-1",
              )
        }}
      </div>
      <div
        class="tw-text-[15px] tw-text-[#231F20] tw-font-[400] tw-leading-[145%] tw-mb-[20px]"
      >
        {{
          type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT
            ? isVendorRequest
              ? getComponentUiText(
                  "app-component-assessments-securing-evidence-modal-vendor-description-encrypt-a-1",
                )
              : getComponentUiText(
                  "app-component-assessments-securing-evidence-modal-description-encrypt-a-1",
                )
            : ""
        }}
      </div>
      <div
        class="tw-text-[15px] tw-text-[#231F20] tw-font-[400] tw-leading-[145%]"
      >
        {{
          type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT
            ? isVendorRequest
              ? getComponentUiText(
                  "app-component-assessments-securing-evidence-modal-vendor-description-encrypt-b-1",
                )
              : getComponentUiText(
                  "app-component-assessments-securing-evidence-modal-description-encrypt-b-1",
                )
            : getComponentUiText(
                "app-component-assessments-securing-evidence-modal-description-decrypt-1",
              )
        }}
      </div>
      <div
        v-if="type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT && isVendorRequest"
        class="tw-text-[15px] tw-text-[#231F20] tw-mt-[20px] tw-font-[400] tw-leading-[145%]"
      >
        {{
          getComponentUiText(
            "app-component-assessments-securing-evidence-modal-vendor-description-encrypt-c-1",
          )
        }}
      </div>
      <div class="tw-flex tw-items-center">
        <BaseInput
          v-model="form.password"
          :validation="v$.password"
          :placeholder="`${getComponentUiText(
            'app-component-assessments-securing-evidence-modal-password-placeholder-1',
          )} ${
            isVendorRequest && type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT
              ? `(${getComponentUiText(
                  'app-assess-recommendations-action-table-steps-solve-step-optional-1',
                ).toLocaleLowerCase()})`
              : ''
          }`"
          :validate-on-blur="true"
          data-cy-id="modal-securing-evidence-pwd-input"
          :type="showPassword ? 'text' : 'password'"
          :col-input="9"
          :col-title="3"
          :label="getComponentUiText('app-user-login-password-heading-1')"
          :container="`tw-w-[100%]`"
          :col-input-class="'tw-pr-[0px]'"
          :label-class="'tw-pl-[0px] tw-pr-[0px]'"
          :class-name="'align-items-center !tw-w-[100%] !tw-ml-[0px]'"
          :valid-class="'sm:tw-ml-[8px] tw-ml-[15px]'"
        >
          <template #rightInput>
            <span
              class="tw-min-w-[70px] tw-cursor-pointer tw-h-[30px] tw-flex tw-items-center"
              @click="togglePassword"
            >
              <div class="">
                <ViewStreamline
                  v-if="!showPassword"
                  class="tw-mb-[2px]"
                  :color="form.password ? '#387DFF' : '#b7b7b7'"
                />
                <ViewStreamOffline
                  v-if="showPassword"
                  class="tw-mb-[4px]"
                  :color="form.password ? '#387DFF' : '#b7b7b7'"
                />
              </div>
              <span
                class="show-password-label tw-text-[#b7b7b7] tw-ml-1"
                :class="
                  form.password ? '!tw-text-[#387DFF]' : 'tw-text-[#b7b7b7]'
                "
                >{{
                  !showPassword
                    ? getComponentUiText("app-user-login-password-show-1")
                    : getComponentUiText("app-user-login-password-hide-1")
                }}</span
              >
            </span>
          </template>
        </BaseInput>
      </div>
      <div
        v-if="isShowConfirmField && form.password"
        class="tw-flex tw-items-center"
      >
        <BaseInput
          v-model="form.confirm_password"
          :validation="v$.confirm_password"
          :validate-on-blur="true"
          data-cy-id="modal-securing-evidence-confirm-pwd-input"
          :placeholder="
            getComponentUiText(
              'app-component-assessments-securing-evidence-modal-field-confirm-password-placeholder-1',
            )
          "
          :col-input="9"
          :col-title="3"
          :type="showPasswordConfirm ? 'text' : 'password'"
          :label="
            getComponentUiText(
              'app-component-assessments-securing-evidence-modal-field-confirm-password-title-1',
            )
          "
          :container="`tw-w-[100%]`"
          :label-class="'tw-pl-[0px] tw-pr-[0px]'"
          :col-input-class="'tw-pr-[0px]'"
          :class-name="'align-items-center !tw-w-[100%] !tw-ml-[0px]'"
          :valid-class="'sm:tw-ml-[8px] tw-ml-[15px]'"
          @blur="
            () => {
              isValid = true;
              v$.$validate();
            }
          "
        >
          <template #rightInput>
            <span
              class="tw-min-w-[70px] tw-cursor-pointer"
              @click="togglePasswordConfirm"
            >
              <ViewStreamline
                v-if="!showPasswordConfirm"
                class="tw-mb-[2px]"
                :color="form.confirm_password ? '#387DFF' : '#b7b7b7'"
              />
              <ViewStreamOffline
                v-if="showPasswordConfirm"
                class="tw-mb-[4px]"
                :color="form.confirm_password ? '#387DFF' : '#b7b7b7'"
              />
              <span
                class="show-password-label tw-text-[#b7b7b7] tw-ml-1"
                :class="
                  form.confirm_password
                    ? '!tw-text-[#387DFF]'
                    : 'tw-text-[#b7b7b7]'
                "
                >{{
                  !showPasswordConfirm
                    ? getComponentUiText("app-user-login-password-show-1")
                    : getComponentUiText("app-user-login-password-hide-1")
                }}</span
              >
            </span>
          </template>
        </BaseInput>
      </div>
    </div>
    <div
      class="button-container-bottom tw-flex tw-justify-end tw-px-[20px] tw-pb-[20px] sm:tw-px-[40px] sm:tw-pb-[40px]"
    >
      <ButtonLoading
        :title="
          getComponentUiText(
            'app-component-assessment-detail-action-continue-assessment-1',
          )
        "
        data-cy="modal-securing-evidence-continue-btn"
        :is-loading="isLoading"
        @click-action="
          async () => {
            isLoading = true;
            await handleFile();
            isLoading = false;
          }
        "
      />
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import {
  getComponentUiText,
  getPasswordDefaultVendorAttachment,
} from "../../utils/utilities";
import { computed, Ref, ref, watch } from "vue";
import ModalComponent from "../common/modalComponent.vue";
import ModalHeader from "../common/modalHeader.vue";
import BaseInput from "../common/form/baseInput.vue";
import { helpers, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { PropType } from "vue";
import {
  CHECKLIST_TYPE,
  TYPE_MODAL_SECURING_EVIDENCE,
  localStorageKey,
} from "../../utils/constants";
import { showError } from "@/services/apiRoutes";
import store from "@/store";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { encryptText, decryptFileBase64 } from "@/utils/cipher";
import ViewStreamline from "@/components/svgs/viewStreamline.vue";
import ViewStreamOffline from "@/components/svgs/viewStreamOffline.vue";
import ButtonLoading from "@/components/common/buttonLoading.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Assessment } from "@/services/apiRoutes/routes";

const props = defineProps({
  isVendorRequest: {
    type: String,
    required: false,
    default: "",
  },
  show: {
    type: Boolean,
    required: false,
  },
  type: {
    type: String as PropType<keyof typeof TYPE_MODAL_SECURING_EVIDENCE>,
    required: false,
    default: TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT,
  },
  checklistItemId: {
    type: Number,
    required: true,
  },
  attachmentId: {
    type: Number,
    required: true,
  },
  styleClass: {
    type: Object,
    required: false,
    default: () => ({ background: "rgba(0, 0, 0, 0.5)" }),
  },
});
const emit = defineEmits(["update:show", "update:data", "update:close"]);

const isCorrectPassword = ref(false);
const isCallApiGetImg = ref(false);
const dataFile = ref<any>(null);
const showPassword = ref(false);
const showPasswordConfirm = ref(false);
const isShowConfirmField = ref(false);
const isValid = ref(false);
const innerTextContinueBtnRef: Ref = ref(null);
const animationWidth = ref(0);
const isLoadingAPI = ref(false);

const providerId = computed(
  () => store.state.Vendor.checklistVendorRequestedExternalInput.providerId,
);

const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};

let showRef = ref(props.show);
let newDomainValue = ref("");
const isLoading = ref(false);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (props.show === true) newDomainValue.value = "";
  },
);

const rulesDecrypt = {
  password: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
};

const rulesEncrypt = {
  password:
    props.isVendorRequest && props.type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT
      ? {}
      : {
          required: helpers.withMessage(
            () => getComponentUiText("app-common-form-value-required-error-1"),
            required,
          ),
          sameAsPassword: helpers.withMessage(
            () => "",
            (value: string) =>
              value === form.value.confirm_password ||
              !isShowConfirmField.value,
          ),
        },
  confirm_password: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      (value: string) => !!value || !form.value.password,
    ),
    sameAsPassword: helpers.withMessage(
      () =>
        getComponentUiText("app-common-form-value-same-as-password-error-1"),
      (value: string) =>
        value === form.value.password || !isValid.value || !form.value.password,
    ),
  },
};

const form = ref<any>({ password: "" });

let v$ =
  props.type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT
    ? useVuelidate(rulesEncrypt, form)
    : useVuelidate(rulesDecrypt, form);

const handleFile = async () => {
  await v$.value.$validate();
  if (v$.value.password.$invalid) return;
  if (
    props.type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT &&
    !isShowConfirmField.value &&
    form.value.password
  ) {
    v$.value.$reset();
    isShowConfirmField.value = true;
    return;
  } else {
    isValid.value = true;
  }
  if (v$.value.$invalid) return;

  await handleActionclick();
};

const togglePassword = () => {
  if (!form.value.password) return;
  showPassword.value = !showPassword.value;
};

const togglePasswordConfirm = () => {
  if (!form.value.confirm_password) return;
  showPasswordConfirm.value = !showPasswordConfirm.value;
};

const handleCloseModal = () => {
  form.value = { password: "", confirm_password: "" };
  isValid.value = false;
  isShowConfirmField.value = false;
  isLoading.value = false;
  v$.value.$reset();
  if (!isCorrectPassword.value) emit("update:close");
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleActionclick = async () => {
  if (isCallApiGetImg.value || isLoadingAPI.value) return;
  isLoadingAPI.value = true;
  if (innerTextContinueBtnRef.value) {
    animationWidth.value =
      innerTextContinueBtnRef.value.getBoundingClientRect()["width"] as number;
  }
  if (
    props.type === TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT &&
    !props.attachmentId
  ) {
    isCorrectPassword.value = true;
  } else {
    await checkPasswordConfirm();
  }

  const password = !form.value.password
    ? getPasswordDefaultVendorAttachment(providerId.value)
    : form.value.password;

  if (isCorrectPassword.value) {
    const pwdFeIv = localStorage.getItem(localStorageKey.pwdFeIv) ?? "";
    const passwordEncrypt = await encryptText(form.value.password, pwdFeIv);

    eventEmitter.emit(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, {
      password: props.isVendorRequest ? password : passwordEncrypt,
      checklistItemId: props.checklistItemId,
    });
    handleCloseModal();
    emit("update:data", password, dataFile.value);
  } else {
    showError("app-component-assessments-securing-evidence-modal-error-1");
  }
  isLoadingAPI.value = false;
};

const checkPasswordConfirm = async () => {
  try {
    let res;
    isCallApiGetImg.value = true;
    if (props.isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
      res = await store.dispatch(
        "Vendor/fetchVendorRequestedExternalAttachment",
        props.attachmentId,
      );
    } else {
      if (props.isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
        res = await store.dispatch(
          "Vendor/fetchVendorRequestedAttachment",
          props.attachmentId,
        );
      } else {
        res = await store.dispatch(
          "Assessment/getAttachment",
          props.attachmentId,
        );
      }
    }

    dataFile.value = res;
    const file = await decryptFileBase64(res.data.data, form.value.password);
    if (file) {
      isCorrectPassword.value = true;
    } else {
      isCorrectPassword.value = false;
    }
    isCallApiGetImg.value = false;
  } catch (error) {
    showErrorAPI(error, Assessment.getAttachment);
  }
};
</script>

<style scoped lang="scss">
.modal-add-domain input::placeholder {
  font-size: 15px !important;
}
.show-password-label {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
}
</style>
